import React from 'react';
import styled from 'styled-components';
import SvgIcon from '../SvgIcon';

const IconExpand = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <path
      d="M8 3 4 7h8L8 3Zm0 10L4 9h8l-4 4Z"
      fillRule="evenodd"
      fill={color}
    />
  ),
})``;

export default IconExpand;
